export default async (axios, nivel) => {
    try {
        const response = await axios.get('/hierarquias')

        const hierarquias = nivel? response.data.hierarquias.filter((element) => element.nivel >= nivel ) : response.data.hierarquias
        return hierarquias
    } catch (error) {
        this.$store.dispatch('showError', error)
    }
}